import providerState from './providerState'
import { LOAD_USER_ORDERS_SUMMARY, LOAD_CART_ITEMS_COUNT } from '../redux/actionsTypes'
import { getUserOrdersSummary } from '../api/orders'
import {getCartItemsCount}  from '../api/store'

/**
 * Represent the orders logic and API in the system
 */
class Orders {
  /**
   * Set **state.userOrdersSummary** with the summary of the orders of the currently logged in user.
   * @returns {UserOrdersSummaryModel} - if the store require order approval then the summary else null
   */
  async loadUserOrdersSummary () {
    const state = providerState.get()
    const requireOrderApproval = state.currentStore && state.currentStore.RequireOrderApproval
    if (requireOrderApproval) {
      const userOrdersSummary = await getUserOrdersSummary()
      providerState.dispatch({ type: LOAD_USER_ORDERS_SUMMARY, data: userOrdersSummary })
      return userOrdersSummary
    }
    return null
  }

  async loadCartItemsCount () {
    const cartItemsCount = await getCartItemsCount()
    providerState.dispatch({ type: LOAD_CART_ITEMS_COUNT, data: cartItemsCount })
    return cartItemsCount
  }
}

export default new Orders()
